<template>
  <div>
    <div class="tweets" ref="tweets">
      <a v-if="latestData" class="tweets__latest" :href="latestData.source.url" target="_blank">
        <div class="tweets__latest__profile">
          <img :src="latestData.author.picture" />
          {{ latestData.author.name }}
        </div>
        <div class="tweets__latest__content">
          <div v-if="latestData.images.medium_square" class="tweets__latest__content__image-wrap">
            <img :src="latestData.images.medium_square" />
          </div>
          <div class="tweets__latest__content__text">
            {{ latestData.details.description }}
          </div>
        </div>
      </a>
      <ul class="tweets__list" v-if="data">
        <li class="tweets__item" v-for="tweet in data">
          <a :href="tweet.source.url" target="_blank">
            <div class="tweets__item__profile">
              <img :src="tweet.author.picture" />
              <span>{{ tweet.author.name }}</span>
            </div>
            <div class="tweets__item__content">
              <div v-if="tweet.images.medium_square" class="tweets__item__content__image-wrap">
                <img :src="tweet.images.medium_square" />
              </div>
              <div class="tweets__item__content__text">
                {{ tweet.details.description }}
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div ref="scrollTarget"/>
    </div>

    <Loading v-if="isRequesting"/>
    <button v-else-if="visibleMore" class="button-more" @click="$emit('click-more')">もっと見る</button>
  </div>
</template>

<style lang="scss" scoped>
.tweets {
  margin-bottom: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  &__latest, > ul > li {
    box-shadow: $shadow;
    background-color: #fff;
  }
  &__latest {
    display: block;
    padding: 20px 30px;
    margin-bottom: 24px;
    &__profile {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 1.4rem;
      > img {
        max-width: 30px;
        max-height: 30px;
        margin-right: 8px;
        background-color: #fafafa;
      }
    }
    &__content {
      display: flex;
      &__image-wrap {
        width: 340px;
        margin-right: 30px;
        text-align: center;
        line-height: 0;
        background-color: #efefef;
        > img {
          max-width: 340px;
          max-height: 250px;
        }
      }
      &__text {
        flex: 1;
        font-size: 2.6rem;
        text-align: left;
        color: #6F7071;
        word-break: break-all;
        word-wrap : break-word;
      }
    }
    @include media-sp() {
      padding: 8px;
      margin-bottom: 12px;
      &__profile {
        margin-bottom: 4px;
        font-size: 1.2rem;
        line-height: 1;
        > img {
          max-width: 24px;
          max-height: 24px;
          margin-right: 4px;
        }
      }
      &__content {
        &__image-wrap {
          width: 108px;
          margin-right: 8px;
          > img {
            max-width: 100%;
          }
        }
        &__text {
          font-size: 1.3rem;
        }
      }
    }
  }
  .tweets__list {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    @include media-sp() {
      margin: 0 -6px;
    }
  }
  &__item {
    margin: 0 10px 20px;
    width: calc(25% - 20px);
    > a {
      display: block;
      padding: 8px 16px;
      height: 100%;
    }
    &__profile {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      text-align: left;
      > img {
        max-width: 30px;
        max-height: 30px;
        margin-right: 8px;
        background-color: #fafafa;
      }
      > span {
        font-size: 1.2rem;
      }
    }
    &__content {
      &__image-wrap {
        width: 100%;
        margin-bottom: 12px;
        text-align: center;
        line-height: 0;
        background-color: #efefef;
        > img {
          max-height: 150px;
        }
      }
      &__text {
        flex: 1;
        font-size: 1.6rem;
        text-align: left;
        color: #6F7071;
        word-break: break-all;
        word-wrap : break-word;
      }
    }
    @include media-sp() {
      margin: 0 6px 20px;
      width: calc(50% - 12px);
      > a {
        padding: 8px;
      }
      &__profile {
        margin-bottom: 6px;
        > img {
          max-width: 20px;
          max-height: 20px;
          margin-right: 4px;
        }
        > span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1;
          font-size: 1.1rem;
        }
      }
      &__content {
        &__image-wrap {
          margin-bottom: 8px;
          > img {
            width: 100%;
          }
        }
        &__text {
          font-size: 1.3rem;
        }
      }
    }
  }
  @include media-sp() {
    max-height: 560px;
    margin: 0 12px 32px;
    overflow-y: scroll;
    overflow-x: hidden;
    box-shadow: $shadow;
  }
}

.button-more {
  width: 280px;
  padding: 12px 0;
  margin: 0 auto 28px;
  background-color: #fff;
  border-radius: 40px;
  box-shadow: $shadow;
  text-align: center;
  font-family: KFhimaji, sans-serif;
  font-size: 1.8rem;
  line-height: 1.4;
  @include media-sp() {
    width: 90%;
    margin: 0 auto 16px;
    font-size: 1.6rem;
    line-height: 1;
  }
}
</style>

<script>
import Loading from './Loading'
export default {
  name: 'Tweets',
  components: {
    Loading
  },
  props: {
    latestData: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    },
    isRequesting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleMore: true
    }
  },
  methods: {
    setVisibleMore(visible) {
      this.visibleMore = visible
    }
  }
}
</script>